module.exports = __webpack_public_path__ + "static/media/popupDouble2.c087b58e.png";